import { newsApi } from './api';


export const PermitService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getPermits: build.query({
            query: ({pagination}) => ({
                url: `permits${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addPermit: build.mutation({
            query: (form) => ({
                url: `permits`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editPermit: build.mutation({
            query: ({ id, newForm }) => ({
                url: `permits/${id}`,
                method: 'PATCH',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removePermit: build.mutation({
            query: (id) => ({
                url: `permits/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetPermitsQuery,
    useAddPermitMutation,
    useEditPermitMutation,
    useRemovePermitMutation,
} = PermitService